<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";
import Spinner from "../../../components/Spinner.vue";

import Attachments from "../../Attachments.vue";

export default Vue.extend({
  mixins: [messages, toasts],
  components: {
    Attachments,
    Spinner,
  },
  data() {
    return {
      isReady: false,
      article: null,
      imageUploadsInProgress: 0,
      //   modified: false,
      //   entry: null,
      endpoint: "/api/news",
      messages: {
        remove: {
          title: "Удаление публикации",
          message: "Вы действительно хотите удалить данную публикацию?",
          confirm: "Удалить",
          cancel: "Отмена",
          success: "Публикация была успешно удалена",
        },
      },
    };
  },
  computed: {
    savingDisabled() {
      return this.imageUploadsInProgress > 0 || !this.canPublish;
    },
    canPostGenericArticles() {
      return this.$can("post generic articles");
    },
    canPostTaggedArticles() {
      return this.$can("post tagged articles");
    },
    canPublish() {
      return (
        (this.article.tags.length == 0 && this.canPostGenericArticles) ||
        (this.article.tags.length > 0 && this.canPostTaggedArticles)
      );
    },
    publishedWithEmail() {
      return (
        this.article.published_at != null && this.article.send_email == true
      );
    },
  },
  methods: {
    onReady(ready) {
      this.isReady = ready;
    },
    update(article) {
      this.article = article;
      this.article.images_to_remove = this.article.images_to_remove || [];
    },
    async submitAndClose() {
      await this.submit();
      this.$loading.open();
      setTimeout(() => {
        location = "/news?section=authored";
      }, 500);
    },
    async submit(hasLoadingSpinner = true) {
      await this.save(hasLoadingSpinner);
      if (this.article.published_at == null) {
        this.toast("info", "Новость была сохранена в черновик");
      }
    },
    async publish(publish = true) {
      let loading = this.$loading.open();

      await this.save(false);

      axios
        .put(
          `${this.endpoint}/${this.article.id}/${
            publish ? "publish" : "unpublish"
          }`
        )
        .then(({ data }) => {
          this.article.published_at = data.published_at;
          this.article.send_email = data.send_email;

          if (loading) loading.close();
          if (publish) {
            this.toast("success", "Новость была успешно опубликована");
          } else {
            this.toast("info", "Новость была снята с публикации");
          }
        })
        .catch((error) => {
          if (loading) loading.close();
          switch (error.response.status) {
            case 422: {
              let errors = error.response.data.errors;
              let key = _.first(_.keys(errors));
              this.toast("warning", _.first(errors[key]));
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
              break;
            }
          }
        });
    },
    unpublish() {
      this.publish(false);
    },
    save(hasLoadingSpinner = true) {
      return new Promise((resolve, reject) => {
        let loading = hasLoadingSpinner ? this.$loading.open() : null;
        axios
          .put(`${this.endpoint}/${this.article.id}`, this.article)
          .then((response) => {
            if (loading) loading.close();
            resolve();
          })
          .catch((error) => {
            if (loading) loading.close();
            switch (error.response.status) {
              case 422: {
                let errors = error.response.data.errors;
                let key = _.first(_.keys(errors));
                this.toast("warning", _.first(errors[key]));
                break;
              }
              default: {
                this.modified = true;
                this.toast("error", "@unexpected", error);
                break;
              }
            }
            reject(error);
          });
      });
    },
    remove() {
      this.$dialog.confirm({
        title: this.messages.remove.title,
        message: this.messages.remove.message,
        confirmText: this.messages.remove.confirm,
        cancelText: this.messages.remove.cancel,
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`${this.endpoint}/${this.article.id}`)
            .then((response) => {
              location.href = "/news";
            })
            .catch((error) => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        },
      });
    },
    async onImageUploading(file) {
      this.imageUploadsInProgress++;
    },
    async onImageUpload(url) {
      this.imageUploadsInProgress--;
      await this.save(false);
      this.toast("info", "Новость была сохранена");
    },
    async onImageRemove(list) {
      console.log(list);
      this.article.images_to_remove = list;
    },
    create() {
      let loading = this.$loading.open();

      axios
        .post("/api/news/create")
        .then(({ data: article }) => {
            window.open(`/news/${article.id}/edit`, "_self");
        })
        .catch((error) => {
          loading.close();
          this.toast("error", "@unexpected", error);
        });
    },
  },
});
</script>

<style lang="sass">
@import "~bulma/sass/utilities/_all"
@import "~bulma/sass/base/_all"

+desktop
    .article-form.field
        margin-top: 1.875em

.ql-tooltip
    z-index: 1
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/views/news/Edit.vue